import { c as _c } from "react/compiler-runtime";
import { MissionNoti } from '@module/svg/icons';
import type { MissionMessage } from '@module/types/centrifuge/public-message/missionMessageTypes';
import BaseLottie from '@pc/components/lottie/BaseLottie';
interface MissionBoxProps {
  color: string;
  message: string;
  image?: string;
  jsonImageUrl?: string;
  backgroundColor: string;
  title?: string;
}
function MissionBox(t0) {
  const $ = _c(23);
  const {
    color,
    message,
    image,
    jsonImageUrl,
    backgroundColor,
    title
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = {
      borderColor: color
    };
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== message) {
    t2 = <div className="text-baseFg">{message}</div>;
    $[2] = message;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== jsonImageUrl) {
    t3 = jsonImageUrl && <BaseLottie src={jsonImageUrl} loop={2} />;
    $[4] = jsonImageUrl;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== image || $[7] !== jsonImageUrl) {
    t4 = !jsonImageUrl && image && <img alt="mission" src={image} width={120} />;
    $[6] = image;
    $[7] = jsonImageUrl;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="mx-auto mt-[16px] min-h-[108px] w-[120px]">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== backgroundColor || $[13] !== color) {
    t6 = {
      backgroundColor,
      color
    };
    $[12] = backgroundColor;
    $[13] = color;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6 || $[16] !== title) {
    t7 = <div className="mx-auto mt-[16px] w-[192px] rounded-[8px] px-[14px] py-2 text-[13px]" style={t6}>{title}</div>;
    $[15] = t6;
    $[16] = title;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t1 || $[19] !== t2 || $[20] !== t5 || $[21] !== t7) {
    t8 = <div className="mx-auto mt-6 mb-2 w-[232px] rounded-[10px] border-2 py-4 text-center text-[13px]" style={t1}>{t2}{t5}{t7}</div>;
    $[18] = t1;
    $[19] = t2;
    $[20] = t5;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}
interface Props {
  item: MissionMessage;
}
function MissionChat(t0) {
  const $ = _c(16);
  const {
    item
  } = t0;
  const {
    type,
    data
  } = item.data.message;
  if (!data) {
    return null;
  }
  const {
    nick,
    coin,
    title,
    image,
    json
  } = data;
  let t1;
  if ($[0] !== image || $[1] !== json || $[2] !== title) {
    t1 = {
      image,
      jsonImageUrl: json,
      title
    };
    $[0] = image;
    $[1] = json;
    $[2] = title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const commonProps = t1;
  if (type === "add") {
    const t2 = `${nick}님이 하트 ${coin}개로 미션 등록!`;
    let t3;
    if ($[4] !== commonProps || $[5] !== t2) {
      t3 = <MissionBox {...commonProps} color="#c98136" message={t2} backgroundColor="#fbf5e0" />;
      $[4] = commonProps;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  if (type === "spon") {
    const t2 = `${nick}님이 미션에 하트 ${coin}개 후원 추가!`;
    let t3;
    if ($[7] !== commonProps || $[8] !== t2) {
      t3 = <MissionBox {...commonProps} color="#c98136" message={t2} backgroundColor="#fbf5e0" />;
      $[7] = commonProps;
      $[8] = t2;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  if (type === "success") {
    const t2 = `미션 성공! 하트 ${coin}개 후원 감사합니다.`;
    let t3;
    if ($[10] !== commonProps || $[11] !== t2) {
      t3 = <MissionBox {...commonProps} color="#3d69ad" message={t2} backgroundColor="#ddebfb" />;
      $[10] = commonProps;
      $[11] = t2;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    let t4;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="-tracking-[0.5px] flex items-start gap-1"><MissionNoti className="pt-1" style={{
          fontSize: "11px"
        }} /><span className="text-[12.5px] text-baseFg">미션 성공 시 팬등급, 열혈팬 집계가 순차적으로 변경됩니다.</span></div>;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    let t5;
    if ($[14] !== t3) {
      t5 = <>{t3}{t4}</>;
      $[14] = t3;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    return t5;
  }
  return null;
}
export default MissionChat;